import React from 'react';

import $image_url from 'js/utils/image_url';
import { currentUser } from 'js/utils/user';

type Props = {
  color?: 'gold' | 'white';
};

const PremiumLock = ({ color = 'gold' }: Props) => {
  if (currentUser?.premium) {
    return null;
  } else if (color === 'gold') {
    return <img src={$image_url('premium/Lock-NoCircle-Gold.svg')} />;
  } else if (color === 'white') {
    return <img src={$image_url('premium/Lock-NoCircle-White.svg')} />;
  } else {
    return null;
  }
};

export default PremiumLock;
